import Text from './Text.component';
import { ContentBoxIcon, BoxIcon } from './Details.styles';
import Tooltip from '@material-ui/core/Tooltip';
import { BiInfoCircle } from 'react-icons/bi';
import { memo } from 'react';

interface ProductInformationInterface {
    titleTooltip: string;
    value: string;
    title: string;
    children?: React.ReactNode;
}

function ProductInformation({ value, titleTooltip, title, children }: ProductInformationInterface) {

    return (
        <ContentBoxIcon>
            <Tooltip title={titleTooltip} aria-label="add" placement="top" arrow>
                <BoxIcon>
                    <BiInfoCircle size={20} />
                </BoxIcon>
            </Tooltip>
            {title && <Text title={title} value={value} />}
            {children}
        </ContentBoxIcon>

    );
}

export default memo(ProductInformation)
